module.exports = __webpack_public_path__ + "img/card_230490689.3fb88af3.jpg";